export default __webpack_public_path__ + "static/media/back-course.923a9c85.svg";